import { useState, useRef, useEffect } from "react";

const ColorSelect = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Fermer le menu si on clique à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Supprimer le focus visuel (le "bleu") du bouton quand on clique
  useEffect(() => {
    const btn = buttonRef.current;
    if (!btn) return;
    const removeFocus = () => btn.blur();
    btn.addEventListener("mouseup", removeFocus);
    btn.addEventListener("mouseleave", removeFocus);
    return () => {
      btn.removeEventListener("mouseup", removeFocus);
      btn.removeEventListener("mouseleave", removeFocus);
    };
  }, []);

  return (
    <div
      className="color-select"
      ref={dropdownRef}
      style={{ position: "relative", width: "170px" }}
    >
<button
  tabIndex={-1}
  onClick={() => setIsOpen(!isOpen)}
  style={{
    width: "100%",
    backgroundColor: value.color || value,
    color: "#fff",
    padding: "5px 5px",
    marginBottom: "1rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
    textAlign: "right",
    cursor: "pointer",
  }}
>
  {options.find((opt) => opt.color === (value.color || value))?.label || "None"} ▼
</button>

      {isOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            margin: 0,
            marginTop: "-1rem",
            padding: 0,
            listStyle: "none",
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
            maxHeight: "280px",
            overflowY: "auto",
            zIndex: 1000
          }}
        >
          {options.map(({ color, label }) => (
            <li
              key={color}
              onClick={() => {
                onChange(color);
                setIsOpen(false);
              }}
              style={{
                backgroundColor: color,
                color: "#fff",
                padding: "5px 10px",
                cursor: "pointer"
              }}
            >
              {label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ColorSelect;
